import * as yup from "yup";

const financialFormSchema = yup.object().shape({
  routeNetWork: yup.boolean().required("Cotação malha aérea é obrigatório"),
  insurance: yup.boolean().required("Seguro em todos é obrigatório"),
  paymentSelected: yup.string().required("Forma de pagamento é obrigatório"),
  paymentMethod: yup
    .array()
    .of(yup.string())
    .min(1, "Selecione ao menos uma forma de pagamento"),
  paymentMethodObs: yup.string().optional(),
  billingSelected: yup.string().required("Faturamento é obrigatório"),
  billing: yup
    .array()
    .of(yup.string())
    .min(1, "Selecione ao menos uma opção de faturamento"),
  billingObs: yup.string().optional(),
});

export default financialFormSchema;
